
import TextTitle from 'widget-components/components/TextTitle/TextTitle.vue'
import TextPlain from 'widget-components/components/TextPlain/TextPlain.vue'
import TextCopiable from 'widget-components/components/TextCopiable/TextCopiable.vue'
import GraphicImage from 'widget-components/components/GraphicImage/GraphicImage.vue'
import ActionButton from 'widget-components/components/ActionButton'
import DisplayDocument from 'widget-components/components/DisplayDocument'
import Divider from 'widget-components/components/Divider'
import EmptySpace from 'widget-components/components/EmptySpace'
import InputCheckbox from 'widget-components/components/InputCheckbox'
import InputCheckboxList from 'widget-components/components/InputCheckboxList'
import InputConsentList from 'widget-components/components/InputConsentList'
import InputCountry from 'widget-components/components/InputCountry'
import InputDate from 'widget-components/components/InputDate'
import InputDateTime from 'widget-components/components/InputDateTime'
import InputDigit from 'widget-components/components/InputDigit'
import InputDocument from 'widget-components/components/InputDocument'
import InputFile from 'widget-components/components/InputFile/InputFile.vue'
import InputDropdown from 'widget-components/components/InputDropdown'
import InputEmail from 'widget-components/components/InputEmail'
import InputNumber from 'widget-components/components/InputNumber'
import InputPhoneNumber from 'widget-components/components/InputPhoneNumber'
import InputRadio from 'widget-components/components/InputRadio'
import InputRadioList from 'widget-components/components/InputRadioList'
import InputSlider from 'widget-components/components/InputSlider'
import InputText from 'widget-components/components/InputText'
import ListView from 'widget-components/components/ListView'
import ProgressBar from 'widget-components/components/ProgressBar'
import SelectionList from 'widget-components/components/SelectionList'
import Stepper from 'widget-components/components/Stepper'
import Container from 'widget-components/components/Container/Container.vue'
import TabbedContainer from 'widget-components/components/TabbedContainer/TabbedContainer.vue'
import Toggle from 'widget-components/components/Toggle/Toggle.vue'
import InputTextArea from 'widget-components/components/InputTextarea/InputTextarea.vue'
import RepeatableContainer from 'widget-components/components/RepeatableContainer/RepeatableContainer.vue'
import ErrorText from 'widget-components/components/ErrorText/ErrorText.vue'
import CheckTrigger from 'widget-components/components/InputCheckbox/CheckTrigger.vue'
import InputConsent from 'widget-components/components/InputConsent/InputConsent.vue'
import InputFileUpload from 'widget-components/components/InputFileUpload/InputFileUpload.vue'
import VeriffFileUpload from 'widget-components/components/VeriffFileUpload/VeriffFileUpload.vue'
import VeriffDocumentUpload from 'widget-components/components/VeriffDocumentUpload/VeriffDocumentUpload.vue'
import ComplyCubeDocumentUpload from 'widget-components/components/ComplyCubeDocumentUpload/ComplyCubeDocumentUpload.vue'
import Position from 'widget-components/components/Position/Position.vue'

export default {
    ActionButton,
    EmptySpace,
    ErrorText,
    GraphicImage,
    CheckTrigger,
    InputCheckbox,
    InputCheckboxList,
    InputRadioList,
    Toggle,
    InputConsent,
    InputConsentList,
    InputDate,
    InputDateTime,
    InputDigit,
    InputFileUpload,
    InputFile,
    InputDocument,
    VeriffFileUpload,
    VeriffDocumentUpload,
    ComplyCubeDocumentUpload,
    InputDropdown,
    InputEmail,
    InputNumber,
    InputPhoneNumber,
    InputRadio,
    InputSlider,
    InputText,
    InputTextArea,
    Position,
    SelectionList,
    TextCopiable,
    TextPlain,
    TextTitle,
    DisplayDocument,
    ProgressBar,
    Stepper,
    Divider,
    ListView,
    Container,
    InputCountry,
    RepeatableContainer,
    TabbedContainer,
}
